import { connect } from 'react-redux';
import { compose } from 'redux';
import _ from 'lodash';

import injectReducer from 'utils/injectReducer';
import EventsGrid from '../components/EventsGrid';
import { eventsEntityActions, eventsEntitySelectors } from 'containers/App/modules/entities/events/eventsEntity.slice';
import { eventsActions, eventsSelectors } from '../modules/events.slice';
import eventsReducer from '../modules/events.slice';
import { dbSelectors } from 'containers/App/modules/entities/entities.selectors';
import schema from 'containers/App/modules/api/schema';
import { selectDeviceTypesTreeDataNew, selectDeviceTypesIdToLabelMap } from 'containers/App/modules/app.slice';

const withReducer = injectReducer({
	key: 'events',
	reducer: eventsReducer,
});

const mapStateToProps = (state) => {
	const grid = eventsSelectors.selectEventsGrid(state);
	const currentIds = _.get(state, 'events.eventsGrid.currentIds');
	const dataSelector = dbSelectors.selectEntitiesDenormalized([schema.events], currentIds);
	const denorm = (typeof dataSelector === 'function' ? dataSelector(state) : dataSelector) || [];
	const data = Array.isArray(denorm) ? denorm.filter(Boolean) : [];

	return {
		isLoading: eventsEntitySelectors.selectEventsPending(state),
		data,
		grid,
		deviceTypesTreeData: selectDeviceTypesTreeDataNew(state),
		deviceTypesIdToLabelMap: selectDeviceTypesIdToLabelMap(state),
	};
};

const withConnect = connect(mapStateToProps, {
	fetchEvents: eventsEntityActions.fetchEvents,
	setGridParams: eventsActions.setGridParams,
	resetGridData: eventsActions.resetGridData,
});

export default compose(withReducer, withConnect)(EventsGrid);
